<template>
  <div
    class="combine"
    :class="{
      'combine-athena': theme == 'athena' && style_combination.style == 3,
      'combine-circle': style_combination.style == 3,
      'combine-auto': style_combination.style == 4,
    }"
    v-if="combinations && combinations.status && combinations.items && combinations.items.length > 1"
  >
    <h5>{{ combinations && combinations.title }}</h5>
    <!-- 款式组合样式 - 方形、圆形、自适应 -->
    <div
      class="combine-items c-thumbnail"
      v-if="
        style_combination &&
        (style_combination.style == 0 || style_combination.style == 3 || style_combination.style == 4)
      "
    >
      <div class="combine-item" v-for="(item, index) in combinations.items" :key="item.product_id">
        <a :href="item.product && item.product.public_url" :class="{ acitve: combination_active == index }">
          <img
            @error.once="imageFailure($event, defaultImage)"
            :src="(item.is_main_image && item.product && item.product.image) || item.product_image || defaultImage"
            class="lazyload"
            data-sizes="auto"
            alt
          />
        </a>
      </div>
    </div>
    <!-- 款式组合 - 图文 -->
    <div class="combine-items c-imagetext" v-if="style_combination && style_combination.style == 1">
      <div class="combine-item" v-for="(item, index) in combinations.items" :key="item.product_id">
        <a
          :href="item.product && item.product.public_url"
          :class="{ acitve: combination_active == index }"
          :title="item.display_name || (item.product && item.product.title)"
        >
          <img
            @error.once="imageFailure($event, defaultImage)"
            :src="(item.is_main_image && item.product && item.product.image) || item.product_image || defaultImage"
            class="lazyload"
            data-sizes="auto"
            alt
          />
          <span>{{ item.display_name || (item.product && item.product.title) }}</span>
        </a>
      </div>
    </div>
    <!-- 款式组合 - 下拉框 -->
    <div class="combination-select" v-if="combinations.items ">
      <div class="combination-select__item">
        <a
          @click.prevent="showOptions = !showOptions"
          v-clickoutside="handleClose"
          style="position: relative; padding-right: 30px"
          :title="
            combinations.items[combination_active].display_name ||
            (combinations.items[combination_active].product && combinations.items[combination_active].product.title)
          "
        >
          <v-lazy-img
            :data-url="
              (combinations.items[combination_active].is_main_image &&
                combinations.items[combination_active].product &&
                combinations.items[combination_active].product.image) ||
              combinations.items[combination_active].product_image 
            "
          />
          <span>{{
            combinations.items[combination_active].display_name ||
            (combinations.items[combination_active].product && combinations.items[combination_active].product.title)
          }}</span>
          <div
            :class="{
              'arrow-icon-up': showOptions,
              'arrow-icon-down': !showOptions,
            }"
          ></div>
        </a>
      </div>
      <div class="combination-select__option" v-show="showOptions">
        <div
          class="combination-select__option__item combination-select__item"
          v-for="(item, index) in combinations.items"
          :key="item.product_id"
          @click="option_click(index)"
        >
          <a
            @click="showOptions = false"
            :href="item.product && item.product.public_url"
            :title="item.display_name || (item.product && item.product.title)"
          >
            <img
              @error.once="imageFailure($event, defaultImage)"
              :src="(item.is_main_image && item.product && item.product.image) || item.product_image || defaultImage"
              data-sizes="auto"
              alt
            />
            <span>{{ item.display_name || (item.product && item.product.title) }}</span>
          </a>
        </div>
      </div>
      <div class="arrow-icon" v-show="showOptions"></div>
      <div class="arrow-icon2" v-show="showOptions"></div>
    </div>
  </div>
</template>

<script>
import mixClose from '@/js/mixins/mixClose'
export default {
  props: {
    // 款式组合配置
    combinations: {
      default: null,
    },
    // 款式组合卡片类型
    style_combination: {
      type: Object,
      default: null,
    },
    // 默认选中款式组合商品
    combination_active: {
      type: Number,
      default: 0,
    },
    // 主题
    theme: {
      type: String,
      default: null,
    },
  },
  mixins: [mixClose],
  data() {
    return {
      showOptions: false,
    }
  },
  methods: {
    option_click(index) {
      this.combination_active = index
    },
    // mixClose 点击空白处隐藏
    handleClose(e) {
      this.showOptions = false
    },
    // 除自身滚动外隐藏下拉框
    scrollClose(e) {
      if (this.showOptions === true && !e?.srcElement?.className?.includes('combination-select__option')) {
        this.showOptions = false
      }
    },
  },
  mounted() {
    window.addEventListener(
      'scroll',
      this.debounce(() => {
        this.scrollClose();
      }, 200)
    )
  },
}
</script>

<style scoped lang='scss'>
.combine {
  margin-top: 20px;
  margin-bottom: 30px;
  h5 {
    margin-bottom: 10px;
    font-size: 16px;
    color: #2b2b2b;
    font-weight: bold;
  }
  .combine-items {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .combine-item {
      margin: 0 15px 10px 0;
      img {
        width: 46px;
        height: 46px;
        object-fit: cover;
      }
    }
  }
  .c-thumbnail {
    margin: 0 -7.5px;
    .combine-item {
      margin: 0 0 10px 0;
      padding: 0 7.5px;
    }
    a {
      display: block;
      &.acitve {
        border: 1px solid var(--main-btn-bg);
      }
    }
  }
  .c-imagetext {
    justify-content: space-between;
    .combine-item {
      margin: 0 0 10px 0;
      width: 48%;
      img {
        width: 38px;
        height: 38px;
      }
      a {
        display: flex;
        align-items: center;
        padding: 4px;
        border: 1px solid #eee;
        &.acitve {
          border-color: var(--main-btn-bg);
        }
        span {
          margin-left: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          line-height: 20px;
        }
      }
    }
  }
}

.combination-select {
  position: relative;
  cursor: pointer;
  &__item {
    margin: 0 0 10px 0;
    .arrow-icon-up {
      position: absolute;
      right: 10px;
      top: calc(50% - 2.5px);
      border-top: 2px solid #ccc;
      border-right: 2px solid #ccc;
      transform: rotate(-45deg);
      width: 10px;
      height: 10px;
    }
    .arrow-icon-down {
      position: absolute;
      right: 10px;
      border-top: 2px solid #ccc;
      border-right: 2px solid #ccc;
      transform: rotate(135deg);
      width: 10px;
      height: 10px;
    }
    img {
      width: 38px;
      height: 38px;
      object-fit: cover;
    }
    a {
      display: flex;
      align-items: center;
      padding: 5px;
      border: 1px solid #eee;
      span {
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        padding-right: 20px;
        line-height: 20px;
      }
    }
  }
  &__option {
    &__item {
      cursor: pointer;
      a {
        border: none;
      }
      &:hover {
        background-color: #eee;
      }
    }
    position: absolute;
    width: 100%;
    left: 5px;
    max-height: 200px;
    overflow-y: auto;
    padding: 6px 0;
    border: 1px solid #eee;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    z-index: 999;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      opacity: 0;
      transition: opacity 120ms ease-out;
      &:hover {
        opacity: 1;
      }
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(144, 147, 153, 0.3);
      transition: 0.3s background-color;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: #fff;
    }
  }
  .arrow-icon {
    position: absolute;
    bottom: -15px;
    left: 30px;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    transform: rotate(-45deg);
    width: 10px;
    height: 10px;
    background-color: #fff;
  }
  .arrow-icon2 {
    position: absolute;
    bottom: -11px;
    left: 29px;
    width: 12px;
    height: 1px;
    background-color: #fff;
    z-index: 999;
  }
}
.combine {
  &.combine-circle {
    .c-thumbnail {
      a {
        border: 1px solid #cccccc;
        display: block;
        border-radius: 50%;
        padding: 3px;
        width: 50px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        &.acitve {
          border: 2px solid var(--main-btn-bg);
        }
      }
    }
  }
  &.combine-auto {
    .c-thumbnail {
      a {
        img {
          max-width: 60px;
          width: auto;
          height: auto;
        }
      }
    }
  }
  &.combine-athena {
    margin-top: 20px;
    margin-bottom: 0;
    h5 {
      margin-bottom: 20px;
      font-size: 20px;
      color: #3a3a3a;
      font-weight: bold;
    }
    .c-thumbnail {
      a {
        border: 1px solid #cccccc;
        display: block;
        border-radius: 50%;
        padding: 3px;
        width: 52px;
        height: 52px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        &.acitve {
          border: 2px solid var(--main-btn-bg);
        }
      }
    }
  }
}
@media screen and(max-width:768px) {
  .combine {
    margin-top: 10px;
    margin-bottom: 20px;
    .c-imagetext {
      .combine-item {
        a {
          span {
            -webkit-line-clamp: 2;
            line-height: 22px;
          }
        }
      }
    }
  }

  .combine {
    &.combine-athena {
      h5 {
        margin-bottom: 0;
        font-size: 13px;
        line-height: 36px;
      }
      .c-thumbnail {
        justify-content: center;
      }
    }
  }
}
</style>
